import { VariantUpdateModel } from '../models/alternate.model';
import { VariantWithLabel } from 'models/variant.model';

/**
 * The function `mapAlternateTextToAlternateUpdateModel` maps an array of `VariantWithLabel` objects
 * to an array of `AlternateUpdateModel` objects by extracting specific properties from each item.
 * @param {VariantWithLabel[]} data - The `data` parameter is an array of `VariantWithLabel`
 * objects.
 */
export const mapAlternateTextToAlternateUpdateModel = (
    data: VariantWithLabel[],
): VariantUpdateModel[] =>
    data.map((item) => ({
        id: item.id,
        text: item.content,
        component_id: item.component_id,
        label_id: item.label?.id,
        is_master: item.id === item.component_id,
        deleted: false,
        variant_type: item.variant_type,
    }));
